import packageJson from '../package.json' with { type: 'json' };

export const VERSION = packageJson.version;
export const ANALYZER_VERSION = '0.1.80-facts.1';
